import { useEffect, useState } from "react";
import { getEditorPlayhead } from "../../common/playhead_tracker.es6";

// The editor preview as an image needs it: whether the scene clock advances
// (not just the play intent — the interaction gate stops it while playing)
// and a counter of explicit seeks. Read at mount, then followed through
// IdeaTimeline's broadcasts.
export function useTimelinePreview() {
  const [advancing, setAdvancing] = useState(() => !!getEditorPlayhead()?.advancing);
  const [seekId, setSeekId] = useState(() => getEditorPlayhead()?.seekId || 0);
  useEffect(() => {
    const onStatus = (e) => setAdvancing(!!(e.detail && e.detail.advancing));
    const onSeek = (e) => setSeekId(e.detail.seekId);
    document.addEventListener("aidea-timeline-status", onStatus);
    document.addEventListener("aidea-timeline-seek", onSeek);
    return () => {
      document.removeEventListener("aidea-timeline-status", onStatus);
      document.removeEventListener("aidea-timeline-seek", onSeek);
    };
  }, []);
  return { advancing, seekId };
}
